export default "__VITE_ASSET__CkPBnrBI__"